import { URLExtraParams } from './typings';

import Ajax from './lib/ajax';
import gallery from './features/gallery';
import appendURLParams from './helpers/append-url-parameters';
import appendScripts from './lib/append-scripts';
import attachForumEvents from './features/forum';
import getURLHash from './helpers/get-url-hash';
import { GALLERY_PICTURE_PREFIX } from './constants';
import mediaControls from './features/media-controls';
import { blockContextMenu } from './features/prevent-context-menu';

let forumLoading = false;

const loadProfileForum = (uri: string) => {
    const urlExtraParams: URLExtraParams = { partial: 1 };
    const request: Ajax = new Ajax();

    uri = appendURLParams(uri, urlExtraParams);
    return request
        .fetchURL(uri)
        .then((body: string) => {
            const content: HTMLElement | null = document.querySelector('#profileForumPlaceholder');
            if (content) {
                content.classList.add('profile__forum--loaded');
                content.innerHTML = body;
                appendScripts(content);
            }

            attachForumEvents();
        })
        .then(() => {
            return window.removeEventListener('scroll', loadForumOnSroll);
        })
        .then(() => {
            forumLoading = false;
        })
        .catch(() => {
            forumLoading = false;
        });
};

const loadForumOnSroll = () => {
    const loadForumBtn: HTMLAnchorElement | null = document.querySelector('#profileLoadForum');
    const elPos: number = loadForumBtn?.getBoundingClientRect().top || 0;
    const offset: number | undefined = document.querySelector('html')?.scrollTop;

    if (offset && offset > elPos) {
        getForumUrlAndInitiForumLoad(loadForumBtn);
    }
};

const loadForumOnClick = (): void => {
    const loadForumBtn: HTMLAnchorElement | null = document.querySelector('#profileLoadForum');
    loadForumBtn?.addEventListener('click', (e: Event) => {
        e.preventDefault();

        getForumUrlAndInitiForumLoad(loadForumBtn);
    });
};

const loadGalleryOnClick = (): void => {
    const loadGalleryBtn: HTMLAnchorElement | null = document.querySelector('#profileArchivePicturesLoadMoreButton');
    const galleryPicturesMarker: HTMLDivElement | null = document.querySelector('#profileArchivePicturesMarker');
    const galleryPicturesMoreContent: HTMLDivElement | null = document.querySelector('#profileArchivePicturesMoreContent');

    loadGalleryBtn?.addEventListener('click', (e: Event) => {
        e.preventDefault();

        if (galleryPicturesMoreContent) {
            galleryPicturesMarker?.replaceWith(...Array.from(galleryPicturesMoreContent.children));
        }
        loadGalleryBtn.parentElement?.remove();
    });
};

const galleryItemsEvents = (): void => {
    const galleryLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.js-gallery');
    galleryLinks.forEach((link: HTMLAnchorElement) => {
        link.addEventListener('click', (e: Event) => {
            e.preventDefault();
            link.blur();

            const pictureID: number = parseInt(link.dataset.pictureId as string, 10);
            if (!isNaN(pictureID)) {
                gallery(pictureID);
            }
        });
    });

    openGalleryFromHash();
};

const getForumUrlAndInitiForumLoad = (loadForumBtn: HTMLAnchorElement | null) => {
    const forumUrl: string | undefined = loadForumBtn?.dataset.uri;

    if (forumLoading) {
        return;
    }

    forumLoading = true;

    if (forumUrl) {
        loadProfileForum(forumUrl);
    }
};

const openGalleryFromHash = (): void => {
    const hash: string | null = getURLHash(document.location);
    if (hash && hash.includes(GALLERY_PICTURE_PREFIX)) {
        const pictureId = parseInt(hash.split('-')[1], 10);
        if (!isNaN(pictureId)) {
            gallery(pictureId);
        }
    }
};

const attachEvents = (): void => {
    window.addEventListener('scroll', loadForumOnSroll);

    loadForumOnClick();
    loadGalleryOnClick();
    galleryItemsEvents();
    blockContextMenu(document.querySelectorAll('.js-profile__media'));

    // Profile teaser video media controls
    mediaControls('.js-profile__media');
};

attachEvents();
